<template>
  <v-dialog v-model="showDialog" persistent content-class="download-dialog">
    <v-card>
      <v-toolbar class="escalon-dialog-header" height="35">
        <img
          class="modal-axis-logo mr-2"
          src="../../assets/AXIS Logo for Dark Backgrounds - Cropped - Grayscale.png">
        <span><slot name="header"></slot></span>
        <v-spacer/>
        <close-button @click="closeModal"/>
      </v-toolbar>
      <v-card-text class="escalon-dialog-content justify-center">
        <span>Are you sure you want to download the selected exam(s)?</span>
        <button class="btn primary-cta pa-1 mt-1" @click="downloadExamZip">
          Download Exam
        </button>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import closeButton from "../controls/CloseButton";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "downloadExamDialog",
  components: { closeButton },
  computed: {
    ...mapGetters(["examToDownload"]),
    showDialog(){
      return !!this.examToDownload;
    }
  },
  methods:{
    ...mapActions(["downloadExamZip"]),
    closeModal(){
      this.$store.commit("setExamToDownload", null);
    }
  }
}
</script>